import React from 'react';
import { motion } from 'framer-motion';

function Card({ children, className = '', hover = true, ...props }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={hover ? { y: -2, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' } : {}}
      className={`
        bg-gray-800 border border-gray-700 rounded-xl p-6 shadow-lg
        ${className}
      `}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default Card;